import { atom, useAtom } from "jotai";

import { SviData } from "#/types/options";

export const sviDataAtom = atom<SviData | null>(null);

export const useSviData = () => {
  const [sviData, setSviData] = useAtom(sviDataAtom);

  return {
    sviData,
    setSviData,
  };
};
